module.exports = __webpack_public_path__ + "static_1727318417925/img/gift_icon.229b6d65.png";